import React, { useState, useContext } from 'react';
import { Modal, Button, Form, Icon, Dropdown } from 'semantic-ui-react';
import UserContext from 'contexts/UserContext';
import { API } from 'aws-amplify';

const postFeedback = async (user, message) => {
  const apiName = 'KnowMyDayAPI';
  const path = '/contact-us';
  const attrs = {
    body: {
      subject: 'App Feedback',
      name: user.getAttributes().name,
      email: user.getAttributes().email,
      message
    }
  };
  return await API.post(apiName, path, attrs);
}

const FeedbackButton = ({inDropdown = false}) => {
  const [ isOpen, setIsOpen ] = useState(false);
  const [ status, setStatus ] = useState('unsent');
  const [ message, setMessage ] = useState('');
  const appUser = useContext(UserContext);

  const sendFeedback = async () => {
    setStatus('sending');
    await postFeedback(appUser, message);
    setStatus('sent');
  }

  return (
    <React.Fragment>
    {inDropdown ? (
      <Dropdown.Item onClick={() => setIsOpen(true)} icon='question' text='Help' className="desktop-hidden" />
      ): (
        <Button color="teal" onClick={() => setIsOpen(true)}><Icon name='question' /> Help</Button>
      )}
      <Modal size="small" open={isOpen} centered={false}>
        <Modal.Header>Know My Day Feedback</Modal.Header>
        <Modal.Content>
          { status === 'sent' ? (
              <Modal.Description>
                Thanks for your feedback! Our support staff will review your comments and respond if necessary.
              </Modal.Description>
          ) : (
              <Modal.Description>
                <p>Do you have a problem, feature request, or general question about Know My Day? We'd love to hear from you!</p>
                <Form>
                  <Form.TextArea
                    value={message}
                    onChange={(e, {value}) => setMessage(value)}
                  />
                </Form>
              </Modal.Description>
          ) }
        </Modal.Content>

        { status === 'sent' ? (
            <Modal.Actions>
              <Button color='green' onClick={() => { setIsOpen(false); setStatus('unsent'); setMessage(''); }}>Close</Button>
            </Modal.Actions>
        ) : (
            <Modal.Actions>
              <Button onClick={() => { setIsOpen(false); setMessage('');} }>Cancel</Button>
              <Button loading={status === "sending" } color='green' onClick={sendFeedback}>Submit</Button>
            </Modal.Actions>
        ) }
      </Modal>
    </React.Fragment>
  )};

export default FeedbackButton;
